export const common = {
  create: {
    success: '追加が完了しました。',
    fail: '追加に失敗しました。',
  },
  update: {
    success: '編集が完了しました。',
    fail: '編集に失敗しました。',
  },
  delete: {
    success: '削除が完了しました。',
    fail: '削除に失敗しました。',
  },
  import: {
    success: 'インポートが完了しました。',
    fail: 'インポートに失敗しました。',
  },
}
